module.exports = __webpack_public_path__ + "img/logo_centerpoint.daf91d71.png";